import React, { useEffect, useState } from "react";
import { EditableTextField } from "../../../../Global_Component/CustomInputComponent";
import { CustomFileUpload } from "../../../../Global_Component/customFileUplodComponent";
import ClientSerivces from "../../Services/clientService";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  InputLabel,
} from "@mui/material";
import { CustomSecondaryButton, CustomSuccessButton } from "../../../../Global_Component/GlobalButtonComponent";

const CompanyDetailsForm = ({ MoveToNextTab,MoveToPreviousTab}) => {
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [loading,setLoading]=useState(false);
  const [formData,setFormData]=useState({})


  const handleInputChange=(e)=>{
    const {files,name,value,type}=e.target
    if(type=='file'){
      setFormData({...formData,[name]:files[0]})
    }else{
      setFormData({...formData,[name]:value})
    }
  }

  const handleFileUpload = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFiles((prev) => ({ ...prev, [key]: file.name }));
    }
  };


  const handlleSubmit=async()=>{
      const payLoad=new FormData();
      Object.keys(formData).map((key)=>{ payLoad.append(key,formData[key])})

      try {
          setLoading(true)
        const response=await ClientSerivces.createCompanyDetails(payLoad)
          if(response.success){
            setLoading(false);
            MoveToNextTab()
          }

          setLoading(false)

      } catch (error) {
        setLoading(false)
        console.log("error",error)
      }
  }


  useEffect(()=>{
console.log("current form state",formData)
  },[formData])

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
       
        borderRadius: "8px",
        backgroundColor: "#fff",
        height:"100%",
        overflowY:"auto"
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
      >
        Company details
      </Typography>

      <Grid
        container
        sm={12}
        md={12}
        lg={8}
        xl={9}
        spacing={0}
      >
       

        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Name"} name={"name"} onChange={handleInputChange} value={formData.name} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Position"} onChange={handleInputChange}  name={"position"} value={formData.position} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Company Name"} onChange={handleInputChange} name={"companyName"} value={formData.companyName} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Company Official Number"} type="number" onChange={handleInputChange}  name={"officialPhoneNumber"} value={formData.officialPhoneNumber} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Company Email"} onChange={handleInputChange}  name={"email"} value={formData.email} isEdit={true}/>
        </Grid>
        <Grid item md={6}sx={{p:1,m:0}}>
        <EditableTextField label={"Company Website URL"} onChange={handleInputChange}  name={"website"} value={formData.website} isEdit={true}/>
        </Grid>
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Company Address"} onChange={handleInputChange}  name='address' value={formData.address} isEdit={true}/>
        </Grid>
        <Grid item md={6}sx={{p:1,m:0}}>
        <EditableTextField label={"Company PAN"} onChange={handleInputChange}  name='panNumber' value={formData.panNumber} isEdit={true}/>
        </Grid>


        <Grid item md={6}sx={{p:1,m:0}}>
        <CustomFileUpload fileType={"image"}   name={"logoImageUrl"} onChange={handleInputChange} label="Company Logo"/>
        </Grid>
        
        <Grid item md={6}sx={{p:1,m:0}}>
        <CustomFileUpload fileType={"pdf"} name={"establishmentCertificate"} onChange={handleInputChange}  label="Company incorporation Certificate"/>
        </Grid>
       
        <Grid item md={6}sx={{p:1,m:0}}>
        <CustomFileUpload fileType={"pdf"} name={"memorandumCertificate"} onChange={handleInputChange}  label="Company MoA /Memorandum"/>
        </Grid>

        <Grid item md={6}sx={{p:1,m:0}}>
        <CustomFileUpload fileType={"image"}  name={"signatorySignImageUrl"} onChange={handleInputChange}  label="Company Authorised signatory sign"/>
        </Grid>
        <Grid item md={6}sx={{p:1,m:0}}>
        <CustomFileUpload fileType={"image"} name={"companySealImageUrl"} onChange={handleInputChange}  label="Company Round cell "/>
        </Grid>
        <Grid item md={6}sx={{p:1,m:0}}>
        <CustomFileUpload fileType={"pdf"} name={"fssaiCertificate"} onChange={handleInputChange}  label="FSSAI Certificate"/>
        </Grid>
      </Grid>

     <Grid xs={12} sx={{display:"flex",alignItems:"center",justifyContent:"flex-end",gap:1}}>
      <CustomSecondaryButton label={"Back"} sx={{margin:2}} onClick={e=>{MoveToPreviousTab()}}/>
        <CustomSuccessButton label={"Save & Next"} loading={loading} onClick={handlleSubmit}/>
     </Grid>
    </Box>
  );
};

export default CompanyDetailsForm;
